import React from 'react'

import { Link } from 'gatsby'
import styled, { css } from 'styled-components'

import FlexWrapper from '../../components/partials/Flex'
import { BrandColors } from '../../utilities/Colors'

interface IDividerStyles {
  fill?: string
  margin?: string
}

export const DividerWrapper = styled.hr<Partial<IDividerStyles>>`
  ${props => css`
    background: ${props.fill ? props.fill : 'transparent'} !important;
    border: 0;
    display: block;
    height: 1px;
    margin: ${props.margin ? props.margin : 0} !important;
    width: 100%;
  `}
`

const DocsDividerWrapper = styled.hr<Partial<IDividerStyles>>`
  ${props => css`
    background: ${BrandColors.pigeon200} !important;
    border: 0;
    display: block;
    height: 1px;
    margin: 4rem 0 4rem -4rem !important;
    transition: background 0.1s ease-out;
    width: calc(100% + 2.5rem);
  `}
`

const DocsLink = styled(Link)`
  color: ${BrandColors.pigeon800};
  transition: color 0.1s ease-out;
  &:hover {
    color: ${BrandColors.primary};
    ${DocsDividerWrapper} {
      background-color: ${BrandColors.pigeon400} !important;
    }
  }
`

export const DocsDivider = ({ sectionId }: { sectionId: string }) => (
  <DocsLink id={sectionId} to={`/developers/#${sectionId}`}>
    <FlexWrapper justify='space-between'>
      <DocsDividerWrapper />#
    </FlexWrapper>
  </DocsLink>
)

const Divider = ({ ...styles }: IDividerStyles) => {
  return <DividerWrapper {...styles} />
}
export default Divider
